import {FormControl, FormGroup} from '@angular/forms';

export class FormGroupUtil {
    public static validateFormGroup(form: FormGroup) {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateFormGroup(control);
            }
        });
    }
}